import React from 'react';
import { TrendingData } from '../services/mcpClient';

interface TrendingStocksProps {
  trendingData: TrendingData;
}

const TrendingStocks: React.FC<TrendingStocksProps> = ({ trendingData }) => {
  const formatTimestamp = (timestamp: string): string => {
    try {
      const date = new Date(timestamp);
      return date.toLocaleString();
    } catch {
      return timestamp;
    }
  };

  return (
    <div className="trending-container">
      <div className="trending-header">
        <h3>🔥 Trending Stocks - {trendingData.region}</h3>
        <div className="trending-meta">
          <span className="count">{trendingData.count} stocks</span>
          <span className="timestamp">
            Updated: {formatTimestamp(trendingData.jobTimestamp)}
          </span>
        </div>
      </div>
      
      <div className="trending-symbols">
        {trendingData.symbols.map((symbol, index) => (
          <div key={symbol} className="trending-symbol">
            <span className="symbol-rank">#{index + 1}</span>
            <span className="symbol-name">{symbol}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrendingStocks;
